import { render, staticRenderFns } from "./superBGoods.vue?vue&type=template&id=0215e72b&"
import script from "./superBGoods.vue?vue&type=script&lang=js&"
export * from "./superBGoods.vue?vue&type=script&lang=js&"
import style0 from "./superBGoods.vue?vue&type=style&index=0&id=0215e72b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports